<a class="appname" routerLink="/" aria-label="Home Page">
  <app-logo [size]="38"></app-logo>
  <app-site-name></app-site-name>
</a>

<ul>
  <li><a routerLink="/" aria-label="Home Page">Home</a></li>
  <li>
    <a routerLink="/collection/{{newArrivalsNo}}" aria-label="new arrivals">New In</a>
  </li>
  <li><a routerLink="/collection/{{bestSellersNo}}" aria-label="best sellers">Best Sellers</a></li>
  <li><a routerLink="/about-us" aria-label="about {{appname}}">About</a></li>
</ul>